import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  //ListItemSecondaryAction,
  CircularProgress,
} from "@mui/material";
//import ListItemButton from "@mui/material/ListItemButton";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import ImageIcon from '@mui/icons-material/Image';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
//import DescriptionIcon from "@mui/icons-material/Description";
import ArticleIcon from '@mui/icons-material/Article';
import moment from "moment";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SearchBox from "../shared/searchbox";
//import UploadDialog from "../shared/records/upload_dialog";
//import FileUploadIcon from '@mui/icons-material/FileUpload';
import VisibilityIcon from "@mui/icons-material/Visibility";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import PreviewRecordDialog from "../shared/records/previewrecorddialog";
import Viewmore from "../shared/viewmore";
import { pcolor, rcolor, scroll, whitecolor } from "../../style2";

// const useStyles = makeStyles((theme) => ({
//   button: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: 400,
//     fontSize: 14,
//     color: "#001244;",
//     textTransform: "unset",
//     "&:hover": {
//       background: whitecolor,
//     },
//   },
//   maintextlist: {
//     fontWeight: "bold",
//     fontSize: 16,
//     color: pcolor,
//   },
//   sharedownload: {
//     color: rcolor,
//   },
//   checkbox: {
//     color: "green",
//   },
//   docicon: {
//     color: "rgba(17, 92, 113, 0.6)",
//   },
//   line: {
//     border: "0.6px solid rgba(133, 138, 145, 0.4)",
//   },
//   uploadicon: {
//     color: rcolor,
//   },
//   uploadiconborder: {
//     background: "rgba(255, 118, 126, 0.1)",
//     borderRadius: 8,
//     padding: 2,
//   },
//   datetextlist: {
//     fontWeight: "normal",
//     fontSize: 12,
//     color: "#545454",
//   },
//   datelist: {
//     fontWeight: "normal",
//     fontSize: 14,
//     color: rcolor,
//   },
//   shareicon: {
//     color: rcolor,
//   },
//   downloadicon: {
//     color: rcolor,
//   },
//   dropdownicon: {
//     color: "#001244",
//     cursor: "pointer",
//   },
//   menutext: {
//     "& .MuiMenuItem-root": {
//       background: "green",
//     },
//   },
//   listitembutton: {
//     "&:hover": {
//       color: "#EBEEFF",
//     },
//   },
//   paddingLeft: {
//     paddingLeft: 20,
//   },
// }));
const button = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: 14,
  color: "#001244",
  textTransform: "unset",
  "&:hover": {
    background: whitecolor,
  },
};

const maintextlist = {
  fontWeight: "bold",
  fontSize: 16,
  color: pcolor,
};

const sharedownload = {
  color: rcolor,
};

const checkbox = {
  color: "green",
};

const docicon = {
  color: "rgba(17, 92, 113, 0.6)",
};

const line = {
  border: "0.6px solid rgba(133, 138, 145, 0.4)",
};

const uploadicon = {
  color: rcolor,
};

const uploadiconborder = {
  background: "rgba(255, 118, 126, 0.1)",
  borderRadius: 8,
  padding: 2,
};

const datetextlist = {
  fontWeight: "normal",
  fontSize: 12,
  color: "#545454",
};

const datelist = {
  fontWeight: "normal",
  fontSize: 14,
  color: rcolor,
};

const shareicon = {
  color: rcolor,
};

const downloadicon = {
  color: rcolor,
};

const dropdownicon = {
  color: "#001244",
  cursor: "pointer",
};

const menutext = {
  "& .MuiMenuItem-root": {
    background: "green",
  },
};

const listitembutton = {
  "&:hover": {
    color: "#EBEEFF",
  },
};

const paddingLeft = {
  paddingLeft: 20,
};

const menuItemStyle = {
  color: "#001244",
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: 14,
  "&:hover": {
    color: rcolor,
    background: whitecolor,
  },
  tabContainer: {
    background: whitecolor,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
  },
  tabIndicator: {
    backgroundColor: rcolor,
  },
  tab: {
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "16px",
    color: pcolor,
    minWidth: "50%",
  }, scroll: {
    overflow: "auto",

  }
};

// const WhiteBackgroundCheckbox = withStyles((theme) => ({
//   root: {
//     color: "red",
//     "& .MuiIconButton-label": {
//       position: "relative",
//       zIndex: 0,
//     },
//     "&:not($checked) .MuiIconButton-label:after": {
//       content: '""',
//       left: 4,
//       top: 4,
//       height: 15,
//       width: 15,
//       position: "absolute",
//       backgroundColor: "white",
//       zIndex: -1,
//     },
//   },
//   checked: {},
// }))(Checkbox);

function Records_List(props) {
  //const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = React.useState([]);
  const [menuOpen, setMenuOpen] = useState();
  const [anchorEl, setAnchorEl] = useState();
  const [page, setPage] = React.useState(0);
  const [records, setRecords] = useState([]);
  const [sharedRecords, setSharedRecords] = useState([]);
  const [viewMore, setViewMore] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = React.useState(false);
  const [fileList, setFileList] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingShared, setLoadingShared] = useState(false);

  const [error, setError] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);
  const ls = new AccessLocalStorage();
  const uploadTabText = ls.isAdmin() || ls.isPediatrician() ? "Uploaded" : "Received";

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_RECORD
      }/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            //console.log(data);
            setRecords(data.received);
            setSharedRecords(data.shared);
          });
        } else {
          setRecords([]);
          setSharedRecords([]);
          response.json().then(data => {
            //console.log(data);
            setError("An error occurred.");
          }).catch(err => {
            setError(err.message || "An error occurred.");
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    setLoadingShared(true);
    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_RECORD
      }/SharedRecords/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            //console.log(data);
            setSharedRecords(data);
            if (props.sharedrecordreload !== null)
              setCurrentTab(1);
          });
        } else {
          setSharedRecords([]);
          response.json().then(data => {
            //console.log(data);
            setError("An error occurred while retrieving the shared records.");
          }).catch(err => {
            setError(err.message || "n error occurred while retrieving the shared records.");
          });
        }
      })
      .finally(() => {
        setLoadingShared(false);
      });
  }, [props.sharedrecordreload]);

  const tabFilters = {
    0: () => true,
    1: (val) => val.status === "Uploaded",
    2: (val) => val.status === "Shared",
    3: (val) => val.status === "Received",
  };

  records.filter((val) => {
    if (search === "") {
      return tabFilters[currentTab](val);
    } else if (
      Object.values(val).join(" ").toLowerCase().includes(search.toLowerCase())
    ) {
      return tabFilters[currentTab](val);
    }
  });

  const getFilteredRecords = () => {
    return records
      .filter((val) => {
        if (search === "") {
          return val;
        } else if (
          Object.values(val)
            .join(" ")
            .toLowerCase()
            .includes(search.toLowerCase())
        ) {
          return Object.values(val);
        }
      });
  }

  const getFilteredSharedRecords = () => {
    return sharedRecords
      .filter((val) => {
        if (search === "") {
          return val;
        } else if (
          Object.values(val)
            .join(" ")
            .toLowerCase()
            .includes(search.toLowerCase())
        ) {
          return Object.values(val);
        }
      });
  }
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore ? setRowsPerPage(8) : setRowsPerPage(getFilteredRecords().length);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleDropDownMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };
  let closeMenu = () => {
    setMenuOpen(false);
  };

  const isAllSelected =
    records.length > 0 && selected.length === records.length;

  const handleChange = (event) => {
    const value = event.target.value;
    const list = [...selected];
    const index = list.indexOf(Number(value));
    list.includes(Number(value))
      ? list.splice(index, 1)
      : list.push(Number(value));
    setSelected(list);
  };

  const handleChangeAll = () => {
    setSelected(
      selected.length === records.length
        ? []
        : records.map((record) => record.id)
    );
  };

  const handleManualSearch = (value) => {
    search !== value ? setSearch(value) : setSearch("");
  };

  const handleOpenUploadDialog = () => {
    setOpenUploadDialog(true);
  };

  const handleCloseUploadDialog = () => {
    setOpenUploadDialog(false);
  };

  const [comingSoonDialogOpen, setComingSoonDialogOpen] = useState(false);
  const [previewRecord, setPreviewRecord] = useState(null);

  const handleComingSoonDialogOpen = (r) => {
    setComingSoonDialogOpen(true);
    setPreviewRecord(r);
  };

  const handleComingSoonDialogClose = () => {
    setComingSoonDialogOpen(false);
    setPreviewRecord(null);
  };

  const endsWith = (source, target) => {
    return source.indexOf(target, source.length - target.length) !== -1;
  }

  return (
    <Box>
      <Grid container xs={12} alignItems="center" >
        <Grid item xs={12}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            TabIndicatorProps={{ style: { background: rcolor } }}
            variant="fullWidth"
          >
            <Tab
              label={loading ? <>{uploadTabText} <CircularProgress size={20} /></> : uploadTabText}
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: 18,
                textTransform: "unset",
                color: currentTab === 0 ? pcolor : "grey",
              }}
            />
            <Tab
              label={loading || loadingShared ? <>Shared <CircularProgress size={20} /></> : "Shared"}
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: 18,
                textTransform: "unset",
                color: currentTab === 1 ? pcolor : "grey",
              }}
            />
          </Tabs>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Box mt={5}></Box>
          <SearchBox onChange={(newValue) => setSearch(newValue)} />
          <Box mt={1}></Box>
        </Grid>
      </Grid>
      {currentTab === 0 && getFilteredRecords().length > 0 ? <>
        <Box component="div" sx={{ ...scroll, maxHeight: 656, overflow: "auto" }}>
          {getFilteredRecords().sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, rowsPerPage)
            .map((record) => (
              <Box sx={{ paddingY: 1 }} key={record.id}>
                <Box sx={{ ...listitembutton, width: '100%' }} >
                  <Grid container sm spacing={2} alignItems="center" style={{ minHeight: 80 }}>
                    <Grid item xs={11} alignContent="center">
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {record.mime.indexOf("image/") > -1 ? <ImageIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                        {record.mime.indexOf("audio/") > -1 ? <AudioFileIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                        {record.mime.indexOf("video/") > -1 ?
                          <OndemandVideoIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                        {record.mime.indexOf("application/") > -1 && (endsWith(record.displayName, ".pdf")) ?
                          <PictureAsPdfIcon sx={docicon} style={{ fontSize: 50 }} /> : record.mime.indexOf("application/") > -1 ?
                            <ArticleIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                        <Box sx={{ paddingLeft: "15px", display: "flex", flexDirection: "column" }}>
                          <Typography component="div" sx={{ ...maintextlist, fontWeight: "normal", fontSize: "15px" }}>
                            {record.displayName}
                          </Typography>
                          <Typography component="div" display="inline" sx={datetextlist}> Date: {moment(record.createdAt).format("DD/MM/YY")} </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton edge="end" aria-label="Download" onClick={() => handleComingSoonDialogOpen(record)}>
                        <VisibilityIcon sx={downloadicon} />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={line} />
              </Box>
            ))}
        </Box>
        <Grid Container style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Grid item>
            {getFilteredRecords().length >= rowsPerPage ?
              <Viewmore handleViewMore={handleViewMore}></Viewmore> : <Box m={4} />
            }
          </Grid>
        </Grid>
      </> : null} {currentTab === 1 ? <Box>
        {getFilteredSharedRecords().sort((a, b) => new Date(b.date) - new Date(a.date))
          .map((record) => (
            <Box sx={{ paddingY: 1 }} key={record.id}>
              <Box sx={{ ...listitembutton, width: '100%' }} >
                <Grid container sm spacing={2} alignItems="center" style={{ minHeight: 80 }}>
                  <Grid item xs={11} alignContent="center">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {record.mime.indexOf("image/") > -1 ? <ImageIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                      {record.mime.indexOf("audio/") > -1 ? <AudioFileIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                      {record.mime.indexOf("video/") > -1 ?
                        <OndemandVideoIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                      {record.mime.indexOf("application/") > -1 && (endsWith(record.displayName, ".pdf")) ?
                        <PictureAsPdfIcon sx={docicon} style={{ fontSize: 50 }} /> : record.mime.indexOf("application/") > -1 ?
                          <ArticleIcon sx={docicon} style={{ fontSize: 50 }} /> : null}
                      <Box sx={{ paddingLeft: "15px", display: "flex", flexDirection: "column" }}>
                        <Typography component="div" sx={{ ...maintextlist, fontWeight: "normal", fontSize: "15px" }}>
                          {record.displayName}
                        </Typography>
                        <Typography component="div" display="inline" sx={datetextlist}> Date: {moment(record.createdAt).format("DD/MM/YY")} </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={1} alignContent="center">
                    <IconButton edge="end" aria-label="Download" onClick={() => handleComingSoonDialogOpen(record)}>
                      <VisibilityIcon sx={downloadicon} />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
              <Box sx={line} />
            </Box>
          ))}
      </Box> : null}
      <PreviewRecordDialog open={comingSoonDialogOpen} handleClose={handleComingSoonDialogClose} record={previewRecord} />
    </Box >
  );
}

export default Records_List;
